<template>
  <div class="rc-edit-dialog" :style="{ 'border-bottom': borderBottom }">
    <rc-but-list
      class="rc-edit-dialog-but"
      v-bind="$attrs.but"
      :but-data="comBut"
      v-on="$listeners"
      @confirm="editConfirm"
    >
      <template slot-scope="scope">
        <slot name="but" v-bind="scope"></slot>
      </template>
    </rc-but-list>
    <rc-dialog
      v-bind="$attrs"
      :content-type="contentType"
      :visible.sync="visibleDef"
      v-on="$listeners"
    >
      <template v-for="(ss, index) in $scopedSlots" :slot="desc" slot-scope="scope">
        <slot :name="ss" :index="index" v-bind="scope"></slot>
      </template>
    </rc-dialog>
    <rc-desc v-bind="$attrs.desc" :model="row" :data="$attrs['form-item']" :slots="descSlots">
      <template v-for="(desc, index) in componentSlots(descSlots)" :slot="desc" slot-scope="scope">
        <slot :name="desc" :index="index" v-bind="scope"></slot>
      </template>
    </rc-desc>
  </div>
</template>

<script>
import { componentSlots } from "@/components/RcBase/mixins/slotMixins";
import { createTargetObj } from "@/utils";
export default {
  name: "RcEditDialog",
  mixins: [componentSlots],
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: false
    },
    editText: {
      type: String,
      default: "基本信息"
    },
    merge: {
      type: Boolean,
      default: false
    },
    butDataCall: Function,
    borderBottom: {
      type: String,
      default: "8px solid #f9f9fb"
    }
  },
  data() {
    return {
      descSlots: {
        item: ["label", "default"],
        desc: ["title", "extra"]
      },
      contentType: "form",
      defData: [{
        type: "text",
        prop: "edit",
        iconClass: "el-icon-edit",
        name: "orgGroup"
      }],
      visibleDef: false
    };
  },
  computed: {
    comBut() {
      const { merge, defData, $attrs, butDataCall, editText } = this;
      const def = [{ ...defData[0], label: editText }];
      return merge ? (butDataCall ? butDataCall($attrs.butData, def) : [...def, ...$attrs.butData]) : def;
    }
  },
  watch: {
    visible: {
      handler(bool) {
        this.visibleDef = bool;
      },
      immediate: true
    },
    row: {
      handler(val) {
        this.initModel(val);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    editConfirm(but, index) {
      const name = this[but.prop];
      if (name) { name(but, index); };
    },
    edit(but, index) {
      this.visibleDef = true;
    },
    initModel(val) {
      createTargetObj(val, this.$attrs.data);
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-edit-dialog {
    padding: 18px 24px 20px 24px;
}
.rc-edit-dialog-but {
  ::v-deep .el-button{
    color: $scim-text-color;
  }
  ::v-deep i{
    color: $scim-color-primary;
  }
}
</style>
